export const environment = {
  baseApiUrl: 'https://de-vanguard-prod.azurewebsites.net/',
  redirectUrl: 'https://dataexplorer-vanguard.kantar.com/landing',
  kantarClientID: '4260429a-b19a-4dde-9f84-f997d1b212da',
  kantarApiClientID: '72831c65-dbc6-4267-b885-99ef0c133033',
  kantarAuthorityID: 'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  UserGuideUrl: 'https://elearning.easygenerator.com/bcd568f0-29e3-43fb-a042-238bfbb04e6e/',
  UserGuideSnapshotUrl: 'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  logoutURL: 'https://dataexplorer-vanguard.kantar.com/signout-oidc',
  sessionTimeOut: '60',
  env: 'dev',
  showUploadModule: 'false',
  askMePythonUrl: 'https://askmepythonapi-atcphegjdudxbsav.northeurope-01.azurewebsites.net/',
  dedicatedCss: 'true',
};
